// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const resetSearchResults = () => ({
    data: [],
    type: actions.RESET_REPORT_SEARCH_RESULTS
});



// WEBPACK FOOTER //
// ./src/reports/shared/action-creators/reset-search-results.js